export default "__VITE_ASSET__BHZXsTEd__"